import windowTintHero from "@/assets/window-tint-hero.jpg";
import paintCorrectionImg from "@/assets/services/paint-correction.jpg";
import mobileMaintenanceImg from "@/assets/services/mobile-maintenance.jpg";

/** Reserved `activeMega` value for the Company mega panel (not a category label). */
export const COMPANY_MEGA_KEY = "company" as const;

export const COMPANY_MEGA_TAGLINE = "Our story & resources";

export const companyMegaItems: readonly {
  name: string;
  desc: string;
  href: string;
  image: string;
}[] = [
  {
    name: "Insights",
    desc: "Articles, tips, and automotive care knowledge.",
    href: "/insights",
    image: windowTintHero,
  },
  {
    name: "Results",
    desc: "Real case studies and transformations.",
    href: "/results",
    image: paintCorrectionImg,
  },
  {
    name: "About Us",
    desc: "Meet the team and our mission.",
    href: "/about-us",
    image: mobileMaintenanceImg,
  },
];
